const PublicUrls = {
  ROOT: "/",
  LOGIN: "login",
  SIGN_UP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  NOT_FOUND: "/404",
} as const;

const PLATFORM = () => "/platform";
const PROFILE = () => `${PLATFORM()}/profile`;
const TEAM_MANAGEMENT = () => `${PLATFORM()}/team-management`;
const SELECT_TEAM_NOTIFY = () => `${PLATFORM()}/select-team`;
const CALENDAR = () => `${PLATFORM()}/calendar`;
const MATCH = () => `${PLATFORM()}/match`;
const TEAM = () => `${PLATFORM()}/team`;

const TEAM_CREATE = () => `${TEAM_MANAGEMENT()}/create`;
const TEAM_EDIT = (id: number) => `${TEAM_MANAGEMENT()}/edit/${id}`;

const WITHBALL_DATA_INPUT = () => `${PLATFORM()}/withball-data-input`;
const MATCH_WITHBALL_DATA_INPUT = (matchId: string) =>
  `${PLATFORM()}/withball-data-input/match/${matchId}`;

const CALENDAR_WITH_DATE = (yearMonth: string) =>
  `${PLATFORM()}/calendar?date=${yearMonth}`;

const CREATE_MATCH = () => `${CALENDAR()}/match/create`;

const MATCH_STATS = (matchId: number | string) => `${MATCH()}/stats/${matchId}`;

const TEAM_STATS = (teamId: number | string) => `${TEAM()}/stats/${teamId}`;

const MATCH_TEAM_STATS = (matchId: number | string, teamId: number | string) =>
  `${MATCH_STATS(matchId)}/team/${teamId}`;

const MATCH_TEAM_PLAYER_STATS = (
  matchId: number | string,
  teamId: number | string,
  playerId: number | string
) => `${MATCH_TEAM_STATS(matchId, teamId)}/player/${playerId}`;

const TEAM_PLAYER_STATS = (
  teamId: number | string,
  playerId: number | string
) => `${TEAM_STATS(teamId)}/player/${playerId}`;

const TEAM_EDIT_URL_PATTERN = `${TEAM_MANAGEMENT()}/edit/:teamId`;
const WITHBALL_DATA_INPUT_URL_PATTERN = `${WITHBALL_DATA_INPUT()}/match/:matchId`;
const MATCH_STATS_PATTERN = `${MATCH()}/stats/:matchId`;
const MATCH_TEAM_STATS_PATTERN = `${MATCH_STATS_PATTERN}/team/:teamId`;
const MATCH_TEAM_STATS_VIDEO_PATTERN = `${MATCH_TEAM_STATS_PATTERN}/video`;
const TEAM_STATS_PATTERN = `${TEAM()}/stats/:teamId`;
const TEAM_SELECTED_STATS_PATTERN = `${TEAM_STATS_PATTERN}/player/:playerId`;
const MATCH_TEAM_PLAYER_STATS_PATTERN = `${MATCH_TEAM_STATS_PATTERN}/player/:playerId`;
const MATCH_TEAM_PLAYER_STATS_VIDEO_PATTERN = `${MATCH_TEAM_PLAYER_STATS_PATTERN}/video`;
const RESET_PASSWORD_URL_PATTERN = `${PublicUrls.RESET_PASSWORD}/:token`;

export const Urls = {
  ...PublicUrls,
  PLATFORM,
  PROFILE,
  TEAM_MANAGEMENT,
  TEAM_CREATE,
  TEAM_EDIT,
  CALENDAR,
  CALENDAR_WITH_DATE,
  CREATE_MATCH,
  WITHBALL_DATA_INPUT,
  MATCH_WITHBALL_DATA_INPUT,
  MATCH_STATS,
  TEAM_STATS,
  MATCH_TEAM_STATS,
  MATCH_TEAM_PLAYER_STATS,
  TEAM_PLAYER_STATS,
  SELECT_TEAM_NOTIFY,
  TEAM_EDIT_URL_PATTERN,
  WITHBALL_DATA_INPUT_URL_PATTERN,
  MATCH_STATS_PATTERN,
  MATCH_TEAM_STATS_PATTERN,
  MATCH_TEAM_STATS_VIDEO_PATTERN,
  TEAM_STATS_PATTERN,
  MATCH_TEAM_PLAYER_STATS_PATTERN,
  MATCH_TEAM_PLAYER_STATS_VIDEO_PATTERN,
  TEAM_SELECTED_STATS_PATTERN,
  RESET_PASSWORD_URL_PATTERN,
};
